import React, { useEffect, useState } from 'react'
import {  postVerYDescargarPDFVigilanciaEpidemiologica, postVigilanciaEpidemiologica } from '../../../services/ControlEnfermeria'
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from '../../../services/ApiHIS';
import ModalSubirYDescargarAchivos from './ModalSubirYDescargarAchivos';
import ModalNoHayArchivosVigilanciaEpidemiologica from './ModalNoHayArchivosVigilanciaEpidemiologica';
import ModalSiHayArchivosVigilanciaEpidemiologica from './ModalSiHayArchivosVigilanciaEpidemiologica';
import Loading from '../../Loading';
import ModalExcelVigilanciaEpidemilogica from './ModalExcelVigilanciaEpidemilogica';
import config from "../../../config";


const VigilanciaEpidemiologicaPrincipal = () => {
    const [dataVigilanciaEpidemiologica, setdataVigilanciaEpidemiologica]=useState([])
    const [modalOnSubirYDescargarAchivos, setmodalOnSubirYDescargarAchivos]=useState(false)
    const [modalOnNoHayArchivos, setmodalOnNoHayArchivos]=useState(false)
    const [modaOnSihayArchivo, setmodaOnSihayArchivo]=useState(false)
    const [dataUser, setdataUser]=useState({})
    const [loading, setloading]=useState(false)
    const [modalOnExcelVP, setmodalOnExcelVP]=useState(false)
    const [actualizarDataVigilacia, setactualizarDataVigilacia]=useState('')

    let query = new URLSearchParams(useLocation().search);
    let tokenCons = JSON.parse(query.get('token'));
    let location = useLocation();

    useEffect(() => {
        // Google Analytics
        //localStorage.removeItem('tokenReact');
        localStorage.setItem('tokenReact',tokenCons)
    }, [location]);
    
      useEffect(()=>{
        //console.log(tokenCons,'tokenConstokenCons')
        const url = UserTokenURL()
    
        // Configurar la cabecera con el token JWT
        const headers = {
          Authorization: `Bearer ${tokenCons}`,
        };
    
        // Realiza la petición con Axios
        axios.get(url, { headers })
        .then(response => {
          //console.log(response.data.user_data, 'data user');
          
          // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
          localStorage.removeItem('usuarioInfo');
          //console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
          // Guarda los nuevos datos
          localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));
    
          //console.log(localStorage.getItem('usuarioInfo'),'antessss')
          // Comprobación de los datos almacenados
          //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
          //console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')
    
          // Resto del código...
        })
        .catch(error => {
          console.error('Error al autenticar al usuario:', error);
          //seterrorEndpoint(true)
        });
      },[])

    useEffect(()=>{
        const dataVilancia={
            "MPCodP":"", //C􀀁digo Pabell􀀁n
            "ClaPro":"", //Clase de Procedimiento
            //"EMPCOD":"1",
            //"MPMCDpto":"001"
        }
        setloading(false)
        
        postVigilanciaEpidemiologica(dataVilancia).then((res)=>{
            //console.log(res.data.data,'data')
            setloading(true)            
            setdataVigilanciaEpidemiologica(res.data.data)
            
        })
    },[actualizarDataVigilacia])

    const handleOnClickSubirYDescargarArchivos=(item)=>{
      setdataUser(item)
      // const validar={
      //   "CodigoDiagnostico":item.MPUdx,
      //   "CodigoCedula": item.MPUced
      // }
      //postVerYDescargarPDFVigilanciaEpidemiologica(validar).then((res)=>{
        //console.log(res.data,'datadescargar')
        //if(res.data[0]){    
          //console.log('data ')      
          //setmodaOnSihayArchivo(true)
        //}else{
          //console.log('data vacia')
          setmodalOnSubirYDescargarAchivos(true)
        //}
      //})
        
    }

    const handleOnClickDescargarArchivo=(item)=>{
      //console.log(item,'tiem data')
      const descargar={
        "CodigoDiagnostico":item.MPUdx,
        "CodigoCedula": item.MPUced,
        "id": item.id
      }
      postVerYDescargarPDFVigilanciaEpidemiologica(descargar).then((res)=>{
        //console.log(res.data,'datadescargar')
        if(res.data[0]){    
          //console.log('data ')      
          window.open(res.data[0].UrlFormato, '_blank', 'noopener,noreferrer');
        }else{
          //console.log('data vacia')
          setmodalOnNoHayArchivos(true)
        }
      })
    }

    //const [codigoDiagnostico, setCodigoDiagnostico] = useState('W541');
  //const [codigoCedula, setCodigoCedula] = useState('16754656');
  //const [error, setError] = useState('');

  const handleDownload = async (item) => {
    console.log(item,'itemmmmm')
    let codigoDiagnostico= item.MPUdx
    let codigoCedula= item.MPUced
    try {

      
      const response = await fetch(`${config.API_URL}/api/cirugias/descargar/epideomologica`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codigoDiagnostico, codigoCedula }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        //setError(errorData.error);
        console.log(errorData.error,'errorData.errorerrorData.error')
        setmodalOnNoHayArchivos(true)
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'VigilanciaEpidemiológica.pdf'); // or use the filename from the response
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      //setError('Error al descargar el PDF');
      console.log(error,'erorrrr')
    }
  };

    //const [pdfUrl, setPdfUrl] = useState(null);

  // const fetchPdf = async () => {
  //   const descargar={
  //     "codigoDiagnostico": "W541",
  //     "codigoCedula":"16754656"
  //   }
  //   try {
  //     const response = await axios.get('http://localhost:8000/api/cirugias/descargar/epideomologica', descargar, {
  //       responseType: 'blob',
  //     });
  //     // Crear una URL para el PDF usando el objeto Blob
  //     const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  //     const pdfUrl = URL.createObjectURL(pdfBlob);
  //     setPdfUrl(pdfUrl);
  //   } catch (error) {
  //     console.error('Error fetching the PDF:', error);
  //   }
  // };

  const handleOnclickExcel=()=>{
    setmodalOnExcelVP(true)
  }

  const handleOnsubmitBuscar=(e)=>{
    e.preventDefault()
    // $MPCodP = $request->MPCodP; codigo pabellon
    // $ClaPro = $request->ClaPro; Clase de Procedimiento
    // $MPNumC = $request->MPNumC; N􀀁mero de Cama
    // $MPNomP = $request->MPNomP; Nombre Pabell􀀁n
    // $MPNOMC = $request->MPNOMC; Nombre Completo Paciente
    // $MPUced = $request->MPUced; Cedula Paciente
    const buscar={
      "MPUced": e.target.documento.value,
      "MPNumC": e.target.cama.value,
      "DMNomb": e.target.codigo.value,
      "MPNomP": e.target.pabellon.value
    }
    setloading(false)
        
        postVigilanciaEpidemiologica(buscar).then((res)=>{
            //console.log(res.data.data,'data')
            setloading(true)            
            setdataVigilanciaEpidemiologica(res.data.data)
            
        })
  }

  return (
    <>
    <h1 className="text-4xl text-[#9e56fe] mb-6 font-semibold">Vigilancia epidemiológica</h1>
    <form onSubmit={handleOnsubmitBuscar}>
          <div className="flex ">
            <div className="mb-3  w-1/5">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                N° Documento
              </label>
              <div className="flex">
                <input
                  name="documento"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="ml-3  w-1/5">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Cama
              </label>
              <div className="flex">
                <input
                  name="cama"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="ml-3  w-1/5">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
               Diagnóstico
              </label>
              <div className="flex">
                <input
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="mb-3  w-2/5 px-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Pabellon
              </label>
              <div className="flex">
                <input
                  name="pabellon"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form >
        <div >
                  <button
                    type="button"
                    onClick={handleOnclickExcel}
                    className="inline-block px-6 py-1.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Excel
                  </button>
                </div>

                <div className='flex text-right'>
                

                </div>
                <div className="flex justify-start items-center space-x-4 pb-3 mt-3">
          <div className="flex items-center">
            <span className="mr-2">No tiene ningun PDF/Imagen subido</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto " width="20" height="20" viewBox="0 0 24 24"><path d="M10 9h-6l8-9 8 9h-6v11h-4v-11zm11 11v2h-18v-2h-2v4h22v-4h-2z" fill="blue"/></svg>
          </div>
          <div className="flex items-center">
            <span className="mr-2">Tiene PDF/Imagen subidos</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto " width="20" height="20" viewBox="0 0 24 24"><path d="M10 9h-6l8-9 8 9h-6v11h-4v-11zm11 11v2h-18v-2h-2v4h22v-4h-2z" fill="green"/></svg>
          </div>
          
          
        </div>
    
    <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                <thead className=" ">
                  <tr>
                    <th>                      
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Subir
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Descargar
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Fecha Archivo
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Codigo Archivo
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Numero cama
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Nombre pabellon
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Paciente
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Documento
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Sexo
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Diagnostico
                    </th>
                    
                  </tr>
                </thead>
                <tbody >
                    {
                      loading?
                        dataVigilanciaEpidemiologica.map((item,index)=>(
                            <tr className=" divide-y divide-slate-700 " key={index}>
                                <td></td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    <div className="">
                                            <button
                                            onClick={()=>handleOnClickSubirYDescargarArchivos(item)}
                                            type="button"
                                            // className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                                            >
                                              {
                                                item.TienePdf === 'S'?
                                                <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto " width="20" height="20" viewBox="0 0 24 24"><path d="M10 9h-6l8-9 8 9h-6v11h-4v-11zm11 11v2h-18v-2h-2v4h22v-4h-2z" fill="green"/></svg>
                                                  :
                                                  <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto " width="20" height="20" viewBox="0 0 24 24"><path d="M10 9h-6l8-9 8 9h-6v11h-4v-11zm11 11v2h-18v-2h-2v4h22v-4h-2z" fill="blue"/></svg>
                                              }
                                            
                                            </button>
                                    </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    <div className="">
                                            <button
                                            onClick={()=>handleOnClickDescargarArchivo(item)}
                                            type="button"
                                            // className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z" fill="blue"/></svg>
                                            </button>
                                    </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    {item.FechaRegistro}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    {item.id}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    {item.MPNumC}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    {item.MPNomP}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    {item.MPNOMC}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    {item.MPUced}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                                    {item.MPSexo}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">                          
                                    {item.DMNomb}
                                </td>
                            </tr>
                        ))
                        :
                        
                          <tr className="divide-y divide-slate-700">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>      
                            <td></td>                      
                            <td><Loading/></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            
                          </tr>
                          
                    }
                </tbody>
                  
                
              </table>
            </div>
          </div>
        </div>
      </div>
      {modalOnNoHayArchivos? <ModalNoHayArchivosVigilanciaEpidemiologica setmodalOnNoHayArchivos={setmodalOnNoHayArchivos}/>:null}
      {modalOnSubirYDescargarAchivos? <ModalSubirYDescargarAchivos setmodalOnSubirYDescargarAchivos={setmodalOnSubirYDescargarAchivos} dataUser={dataUser} setactualizarDataVigilacia={setactualizarDataVigilacia}/>:null}
      {modaOnSihayArchivo? <ModalSiHayArchivosVigilanciaEpidemiologica setmodaOnSihayArchivo={setmodaOnSihayArchivo}/>:null}
      {modalOnExcelVP? <ModalExcelVigilanciaEpidemilogica setmodalOnExcelVP={setmodalOnExcelVP} dataVigilanciaEpidemiologica={dataVigilanciaEpidemiologica}/>:null}
      </>
  )
}

export default VigilanciaEpidemiologicaPrincipal